import Button from '@components/designSystem/Button'
import useTypedTranslation from '@hooks/useTypedTranslation'

// Required by CC BY-SA 4.0, the licence of the dictionary the backend uses to split compound words
// for the product search.
function DictionaryAttribution({ className }: {className?: string}) {
  const { t } = useTypedTranslation()

  return (
    <p className={className}>
      {t('account.licenses.dictionary')}{' '}
      <Button size='sm' variant='link-color' href='https://creativecommons.org/licenses/by-sa/4.0/' target='_blank'>CC BY-SA 4.0</Button>
      {' · '}
      <Button size='sm' variant='link-color' href='https://github.com/danielnaber/jwordsplitter' target='_blank'>{t('account.licenses.source')}</Button>
    </p>
  )
}

export default DictionaryAttribution
